import Icon from 'components/base/Icon';
import { StyledStats } from './Header.style';
import useHeaderStats from './useHeaderStats/useHeaderStats';
import * as LighthouseService from 'common/services/lighthouse.service';
import { ARTICLE_IDS } from 'common/constants/constants';
import useRaCostSetting from '../settings/hooks/useRaCostSetting';
import { getRoundedFte } from '../resource-allocation.formatters';
import { useContext } from 'react';
import ProjectsPeriodPicker from '../../state/filters/components/ProjectsPeriodPicker/ProjectsPeriodPicker';
import Loader from '../../state/filters/components/ProjectsFiltersBar/Loader';
import { StyledWidgetHeader } from 'components/base/common-styles';
import { PROJECTS_FILTERS_CONTEXTS_NAMES } from '../../state/filters/contexts';
import { LBButton } from '@linearb/buzz';

const Stat = ({ icon, iconSize = 'normal', value, text, marginRight }) => (
  <StyledStats marginRight={marginRight} data-testid={`${icon}-icon`}>
    <Icon name={icon} size={iconSize} color='shuttleGray' />
    <StyledWidgetHeader>
      {value} {text}
    </StyledWidgetHeader>
  </StyledStats>
);

const Help = ({ Context }) => {
  const mapContextToArticleId = {
    [PROJECTS_FILTERS_CONTEXTS_NAMES.RESOURCE_ALLOCATION]:
      ARTICLE_IDS.RESOURCE_ALLOCATION,
    [PROJECTS_FILTERS_CONTEXTS_NAMES.INVESTMENT_CARVING]:
      ARTICLE_IDS.INVESTMENT_CARVING
  };
  const articleId = mapContextToArticleId[Context?.name];

  if (!articleId) return null;

  return (
    <LBButton
      variant='ghost'
      size='icon'
      onClick={() => LighthouseService.navigateArticle(articleId)}
    >
      <Icon
        data-testid='help-icon'
        name='helpicon'
        size='smaller'
        color='chambray'
      />
    </LBButton>
  );
};

const Header = ({ Context, SettingsButton, withPeriodPicker = false }) => {
  const {
    state: { period, setPeriod, isInitialized }
  } = useContext(Context);
  const stats = useHeaderStats({ Context });
  const raCost = useRaCostSetting();
  const { projects_count, assignees_count, fte_total } = stats;

  const estCostValue = raCost.calculateCostByFte({
    effortFte: fte_total,
    period
  });

  const roundFte = getRoundedFte(fte_total);

  if (!isInitialized) return <Loader />;

  return (
    <div
      className='flex flex-row justify-between items-center'
      data-cy='summary-header'
    >
      <div className='flex flex-row gap-2 items-center'>
        {withPeriodPicker && (
          <ProjectsPeriodPicker period={period} setPeriod={setPeriod} />
        )}
        <Stat icon='Clipboard' value={projects_count} text='Projects' />
        <Stat icon='TeamsPeopleIcon' value={assignees_count} text='People' />
        <Stat
          icon='PeopleClock'
          value={roundFte}
          text='FTE’s (full-time equivalent)'
          {...(raCost.isEnabled ? {} : { marginRight: '1rem' })}
        />
        {raCost.isEnabled && (
          <Stat
            icon='Cash'
            iconSize='x-medium'
            value={raCost.formatToString(estCostValue)}
            text='Est. Cost'
            marginRight='1rem'
          />
        )}
        <Help Context={Context} />
      </div>
      <div className='flex flex-row justify-end'>
        {SettingsButton && <SettingsButton />}
      </div>
    </div>
  );
};

export default Header;
